import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactoService } from '../services/contacto.service';
@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {

  contacto: FormGroup;
  submitted = false;
  error_contact = false;
  error_general = false;

  asunto = "";
  readOnly = false;
  msg = false;

  constructor(private contactoService: ContactoService, private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.contacto = this.formBuilder.group({
      nombre: ['', Validators.required],
      asunto: ['', Validators.required],
      detalle: ['', Validators.required],
      email: ['', Validators.required],
      facebook: ['', Validators.required],
      telefono: ['', Validators.required]
    });
  }

  get f() { return this.contacto.controls; }

  onSubmit() {
    this.submitted = true;
    this.error_contact = false;
    this.error_general = false;

    if (this.contacto.controls.facebook.errors
      && this.contacto.controls.instagram.errors
      && this.contacto.controls.telefono.errors
      && this.contacto.controls.email.errors) {

      this.error_contact = true;
      this.error_general = true;
      return;
    }
    else {
      if (this.contacto.controls.nombre.errors
        || this.contacto.controls.asunto.errors
        || this.contacto.controls.detalle.errors) {
        this.error_general = true;
      }
      else {
        this.contactoService.send(this.contacto.value).subscribe(val => {
          this.msg = true;
        });


      }
    }

  }

}
